import PropTypes from 'prop-types';
import React from 'react';
import zh_CN from 'antd/lib/locale-provider/zh_CN';
import moment from 'moment';
import { Modal, Button, Form, Input, Radio, Spin, Icon } from 'antd';
import { Select, DatePicker, ConfigProvider, message, Checkbox } from 'antd';
import { Popconfirm } from 'antd';
import { formatDate, emergencyOption, getDay, eventListener } from '../utils';
import { patientSourceOption, isDuringDate, checkDate } from '../utils';
import { checkProv } from '../utils';
import { apis } from '../api/index.js';
import ApplyImgList from './ApplyImgList.js';
import PreviewImg from '../imgs/img-preview.png';
const { TextArea } = Input;
const { Option } = Select;
const { confirm } = Modal;
const timeFormat = 'YYYY-MM-DD HH:mm:ss';
const dateFormat = 'YYYY-MM-DD';
class Apply extends React.Component {
  constructor(props) {
    super(props);
    this.modal = React.createRef();
  }

  static propTypes = {
    visible: PropTypes.bool,
    onCancel: PropTypes.func.isRequired,
    form: PropTypes.object,
    selectedDicom: PropTypes.object,
    viewType: PropTypes.string,
    bodyPartList: PropTypes.array,
    history: PropTypes.object,
    applyToCertId: PropTypes.func,
  };

  state = {
    visible: this.props.visible,
    confirmLoading: false,
    status: 0,
    selectedDicom: {},
    postedUrl: [],
    isNightDefault: null,
    imagePositionList: [{ bodyPart: '', checkPosture: null }],
    applyImgListVisible: false,
    isLoading: false,
    productionId: '101',
    pageId: '10018',
    certIdTipVisible: false,
  };
  componentDidUpdate(prevProps) {
    const { visible, selectedDicom, viewType } = this.props;
    if (prevProps.visible !== visible) {
      this.setState({ visible });
      if (visible) {
        const info = window.store.getState().api.user.info;
        const { certId, nickName } = info;
        if (!certId || nickName.length > 4 || !nickName) {
          this.setState({ certIdTipVisible: true });
        }
        this.props.form.resetFields();
        this.setState({
          selectedDicom,
          viewType,
          postedUrl: [],
          imagePositionList: [{ bodyPart: '', checkPosture: null }],
        });
        if (viewType === 'detail') this.getApplicationInfo(selectedDicom);
        else this.getApply(selectedDicom);

        this.setNightDefault();
      }
    }
  }

  //是否夜间急诊
  setNightDefault = () => {
    const currentTime = new Date().getHours();
    let startDate, endDate;
    if (currentTime >= 0 && currentTime <= 7) {
      startDate = getDay(-1) + ' 17:0:0';
      endDate = getDay(0) + ' 8:0:0';
    } else {
      startDate = getDay(0) + ' 17:0:0';
      endDate = getDay(1) + ' 8:0:0';
    }
    const isNight = isDuringDate(startDate, endDate);
    let isNightDefault = isNight ? 2 : null;
    this.setState({ isNightDefault });
    return isNightDefault;
  };
  //查看申请单详情
  getApplicationInfo = selectedDicom => {
    const id = selectedDicom.applicationId;
    apis.applicationInfo(id).then(res => {
      if (res.code === '0') {
        let selectedDicom = res.data;

        this.getPositionList(selectedDicom);
        const parts = selectedDicom.parts;
        parts.forEach(item => {
          const names = item.checkPostureName || '';
          const ids = item.checkPosture || '';
          item.checkPostureName = names.split(',');
          item.checkPosture = ids.split(',');
        });
        this.setState({ selectedDicom, imagePositionList: parts });
      } else if (res.code === '1009') this.props.history.push('/login');
    });
  };

  //发起申请
  getApply = (selectedDicom, values) => {
    const id = selectedDicom.diagId;
    apis.apply(id).then(res => {
      if (res.code === '0') {
        if (values) {
          values.dicomDrList = res.data.dicomDrList;
          const result = Object.assign({}, res.data, values);
          this.setState({ selectedDicom: result, confirmLoading: false });
        } else {
          this.setState({ selectedDicom: res.data, confirmLoading: false });
        }
      } else if (res.code === '1009') this.props.history.push('/login');
    });
  };

  getPositionList = selectedDicom => {
    let parts = selectedDicom.parts;
    parts.forEach((item, index) => {
      apis.positionList(item.bodyPart).then(res => {
        if (res.code === '0') {
          item.positionList = res.data;
          selectedDicom.parts[index] = item;
          this.setState({ selectedDicom });
        } else if (res.code === '1009') this.props.history.push('/login');
      });
    });
  };

  submitApplyInfo = (type, values) => {
    const info = window.store.getState().api.user.info;
    const { certId, nickName } = info;
    if (!certId || nickName.length > 4 || !nickName) {
      this.setState({ certIdTipVisible: true });
    }
    this.setState({ confirmLoading: true });
    //保存评价内容
    const { selectedDicom } = this.state;
    let { birthday, studyDateTime } = values;
    birthday = birthday ? formatDate(birthday, dateFormat) : undefined;
    studyDateTime = formatDate(values.studyDateTime, timeFormat);
    const post = {
      ...values,
      subVOs: [],
      parts: [],
      diagId: selectedDicom.id,
      birthday,
      studyDateTime,
    };
    let selectedCount = 0;
    for (let i in values) {
      if (i.indexOf('imageId') >= 0) {
        let dicomDrId = i.split('_')[2];
        let key = i.split('_')[1];
        if (values['checkbox_' + key]) selectedCount++;
        post.subVOs.push({
          dicomDrId,
          selectFlag: values['checkbox_' + key] || false,
        });
      }
      if (i.indexOf('part') >= 0) {
        const key = i.split('_')[1];
        const checkValue = values['position_' + key] || [];
        const check = [];
        checkValue.forEach(item => {
          check.push(item.split('_')[0]);
        });

        const bodyPart = values[i].split('_')[0];
        post.parts.push({ bodyPart, checkPosture: check.join(',') });
      }
    }
    if (selectedCount === 0) {
      message.warning('至少选择一张影像才可提交申请');
      this.setState({ confirmLoading: false });
      return false;
    }
    let url = '';
    this.setState({ isLoading: true });
    if (type === 'new') {
      url = apis.saveApplication(post);
    } else if (type === 'update') {
      post.id = selectedDicom.id;
      post.diagId = selectedDicom.diagId;
      url = apis.updateApplication(post);
    }
    url.then(res => {
      this.setState({ isLoading: false, confirmLoading: false });
      if (res.code === '0') {
        message.success('申请成功');
        this.handleCancel(true);
      } else if (res.code === '1005') {
        const _this = this;
        confirm({
          title: '提示',
          content: '该申请单存在新上传的影像，点击“是”加载新的影像',
          okText: '是',
          okType: 'danger',
          cancelText: '否',
          centered: true,
          onOk() {
            selectedDicom.diagId = selectedDicom.id;
            _this.getApply(selectedDicom, values);
          },
          onCancel() {
            _this.setState({ confirmLoading: false });
          },
        });
      } else {
        message.error(res.message);
        this.handleCancel(false);
        if (res.code === '1009') this.props.history.push('/login');
      }
    });
  };
  handleOk = (type, e) => {
    e.preventDefault();
    const isNightDefault = this.setNightDefault();
    const _this = this;
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        if (isNightDefault === 2 && values.emergencyFlag !== 2) {
          confirm({
            title: '提示',
            content:
              '急诊类型修改为夜间急诊吗？否则夜间报告无医生审核，可能导致报告无法下发',
            okText: '确认修改',
            okType: 'danger',
            cancelText: '立即申请',
            centered: true,
            onOk() {
              //点击确认修改，把急诊类型改成夜间急诊再提交
              values.emergencyFlag = 2;
              _this.submitApplyInfo(type, values);
            },
            onCancel() {
              //点击立即申请，直接提交
              _this.submitApplyInfo(type, values);
            },
          });
        } else this.submitApplyInfo(type, values);
      }
    });
  };

  //点击“取消按钮”隐藏对话框
  handleCancel = (changed, type) => {
    const { productionId, pageId } = this.state;
    const eventData = { productionId, pageId, moduleId: 'mk0004' };
    let elementId;
    if (type === 'cancel') elementId = 'ns-002';
    else if (type === 'close') elementId = 'ns-001';
    elementId && eventListener({ ...eventData, elementId });

    this.props.onCancel(changed);
    //点击关闭按钮后初始化预览图片
    const { postedUrl } = this.state;
    postedUrl.map(item => {
      const el = document.getElementById(item);
      const childs = el.childNodes;
      for (let i = childs.length - 1; i >= 0; i--) {
        el.removeChild(childs[i]);
      }
      const img = document.createElement('img');
      img.src = PreviewImg;
      el.appendChild(img);
      return null;
    });
    this.setState({ visible: false });
  };

  getImageWithToken = (url, id) => {
    const { postedUrl } = this.state;
    if (postedUrl.indexOf(id) >= 0) return;
    postedUrl.push(id);
    this.setState({ postedUrl });

    let xmlhttp = new XMLHttpRequest();
    xmlhttp.open('GET', url, true);
    xmlhttp.responseType = 'blob';
    apis.getToken().then(res => {
      const token = res.data.access_token;
      xmlhttp.setRequestHeader('Authorization', 'Bearer ' + token); //该处加上你当前的token
      xmlhttp.onload = function() {
        if (xmlhttp.status === 200) {
          let blob = this.response;
          let img = document.createElement('img');
          img.onload = function(e) {
            window.URL.revokeObjectURL(img.src);
          };
          img.setAttribute('class', 'apply-image-view');
          img.src = window.URL.createObjectURL(blob);

          let el = document.getElementById(id);
          let childs = el.childNodes;
          if (childs && childs.length > 0) {
            for (let i = childs.length - 1; i >= 0; i--) {
              el.removeChild(childs[i]);
            }
          }
          el.appendChild(img);
        }
      };
      xmlhttp.send(null);
    });
  };
  getImageList = type => {
    const { getFieldDecorator } = this.props.form;
    const { selectedDicom } = this.state;

    const api = window.store.getState().api;
    const userId = api.user.info.id;
    const disabled = type === 'detail' && selectedDicom.createUser !== userId;

    let [list, html] = [[], []];
    if (type === 'detail') list = selectedDicom.subVos || [];
    else list = selectedDicom.dicomDrList || [];
    list.map((item, index) => {
      let key = index + 1;
      let url = `/v1/picl/aets/piclarc/rs/studies/${item.studyUid}/series/${item.seriesUid}/instances/${item.sopInstanceId}/frames/1/rendered`;
      html.push(
        <div className="apply-image-list" key={index}>
          {getFieldDecorator(`imageId_${key}_${item.dicomDrId}`, {})(
            <div>
              <img src={PreviewImg} alt="" />
              {item.seriesUid &&
                item.sopInstanceId &&
                this.getImageWithToken(url, `imageId_${key}_${item.dicomDrId}`)}
            </div>
          )}
          <div>
            {getFieldDecorator(`checkbox_${key}`, {
              valuePropName: 'checked',
              initialValue: type === 'detail' ? item.selectFlag : true,
            })(<Checkbox className="apply-checkbox" disabled={disabled} />)}
            <span>{` 影像${key}`}</span>
          </div>
        </div>
      );
      return index;
    });
    return html;
  };

  setPositionList = (index, value) => {
    const [id, name] = value.split('_');

    let { imagePositionList } = this.state;
    imagePositionList[index].bodyPart = id;
    imagePositionList[index].bodyPartName = name;
    imagePositionList[index].checkPosture = null;
    imagePositionList[index].checkPostureName = [];
    this.props.form.setFieldsValue({ [`position_${index}`]: [] });

    apis.positionList(id).then(res => {
      if (res.code === '0') {
        imagePositionList[index].positionList = res.data;

        this.setState({ imagePositionList });
        this.setApplyProject(imagePositionList);
      } else if (res.code === '1009') this.props.history.push('/login');
    });
  };

  handlePostureChange = (index, value) => {
    const { imagePositionList } = this.state;
    const [idList, nameList] = [[], []];
    value.forEach(item => {
      idList.push(item.split('_')[0]);
      nameList.push(item.split('_')[1]);
    });
    imagePositionList[index].checkPosture = idList;
    imagePositionList[index].checkPostureName = nameList;
    this.setState({ imagePositionList });
    this.setApplyProject(imagePositionList);
  };

  //生成申请项目
  setApplyProject = (imagePositionList = []) => {
    const list = [];
    imagePositionList.forEach(item => {
      if (item.bodyPartName && item.checkPostureName.length > 0) {
        list.push(item.bodyPartName + '/' + item.checkPostureName.join('/'));
      }
    });
    this.props.form.setFieldsValue({ applicationItem: list.join('，') });
  };

  changePatientSource = value => {
    const { selectedDicom } = this.state;
    selectedDicom.description = value === 2 ? '体检' : '';
    selectedDicom.medicalHistory = value === 2 ? '体检' : '';
    this.setState({ selectedDicom });
  };

  addPart = () => {
    const { imagePositionList } = this.state;
    imagePositionList.push({ bodyPart: '', checkPosture: null });
    this.setState({ imagePositionList });
  };

  delPart = index => {
    const { imagePositionList } = this.state;
    imagePositionList.splice(index, 1);
    this.setState({ imagePositionList });
    this.setApplyProject(imagePositionList);
  };

  handleReApply = () => {
    message.warning('医生正在为您处理，处理完后才可以重新申请。');
  };

  showImgList = () => {
    const { productionId, pageId } = this.state;
    const eventData = { productionId, pageId, moduleId: 'mk0004' };
    eventListener({ ...eventData, elementId: 'ns-003' });

    this.setState({ applyImgListVisible: true });
  };
  hideImgList = () => {
    this.setState({ applyImgListVisible: false });
  };
  addMoreImg = list => {
    const { selectedDicom } = this.state;
    let { state, dicomDrList, subVos } = selectedDicom;
    let oldDicomList = state === 1 ? dicomDrList : subVos;
    const oldDicomId = oldDicomList.map(item => item.dicomDrId);
    list.forEach(item => {
      if (oldDicomId.indexOf(item.dicomDrId) === -1) {
        if (state === 1) selectedDicom.dicomDrList.push(item);
        else selectedDicom.subVos.push(item);
      }
    });
    this.setState({ selectedDicom });
  };
  handleIDType = value => {
    this.setState({ currentIDType: value });
  };
  IDNoValidator = (rule, value, callback) => {
    const { currentIDType } = this.state;
    //01:居民身份证
    //02:居民户口簿
    //03:护照
    //04:军官证
    //05:驾驶证
    //06:港澳居民来往内地通行证
    //07:台湾居民来往内地通行证
    //08:出生医学证明
    //09:其他法定有效证件
    let [reg, name] = ['', ''];
    if (currentIDType === '01' || currentIDType === '05') {
      name = '居民身份证';
      reg = /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
    } else if (currentIDType === '02') {
      [name, reg] = ['居民户口簿', /\d{9}/];
    } else if (currentIDType === '03') {
      [name, reg] = ['护照', /^([a-zA-z]|[0-9]){9}$/];
    } else if (currentIDType === '04') {
      name = '军官证';
      reg = /^[\u4E00-\u9FA5](字第)([0-9a-zA-Z]{4,8})(号?)$/;
    } else if (currentIDType === '06') {
      name = '港澳居民来往内地通行证';
      reg = /^[HMhm]{1}([0-9]{10}|[0-9]{8})$/;
    } else if (currentIDType === '07') {
      name = '台湾居民来往内地通行证';
      reg = /^\\d{8}|^[a-zA-Z0-9]{10}|^\\d{18}$/;
    }
    if (reg) {
      if (!value) callback(`请输入${name}号码`);
      else if (!reg.test(value)) callback(`${name}号码不合规`);
      else if (currentIDType === '01' || currentIDType === '05') {
        const province = value.substring(0, 2);
        if (!checkProv(province)) callback(`${name}号码不合规`);

        const birthday = value.substring(6, 14);
        if (!checkDate(birthday)) callback(`${name}号码不合规`);

        const sevenTeenIndex = [
          7,
          9,
          10,
          5,
          8,
          4,
          2,
          1,
          6,
          3,
          7,
          9,
          10,
          5,
          8,
          4,
          2,
        ];
        const front17 = value.slice(0, 17);
        let last1 = value.slice(17, 18);
        last1 = isNaN(parseInt(last1)) ? last1.toLowerCase() : parseInt(last1);
        let remainder = 0;
        for (let i = 0; i < 17; i++) {
          remainder += parseInt(front17.charAt(i)) * sevenTeenIndex[i];
        }
        let remainderKeyArr = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2];
        let remainderKey =
          typeof remainderKeyArr[remainder % 11] === 'string'
            ? 'x'
            : remainderKeyArr[remainder % 11];
        if (remainderKey !== last1) callback(`${name}号码不合规`);

        callback();
        const year = value.substring(6, 10);
        const month = value.substring(10, 12);
        const day = value.substring(12, 14);

        const { selectedDicom } = this.state;
        this.setState({
          selectedDicom: {
            ...selectedDicom,
            birthday: moment(`${year}-${month}-${day}`, dateFormat),
          },
        });
      } else {
        callback();
      }
    } else {
      callback();
    }
  };
  applyToCertId = () => {
    this.setState({ certIdTipVisible: false });
    this.props.applyToCertId(true);
  };
  render() {
    let { visible, confirmLoading, selectedDicom, viewType } = this.state;
    let { isNightDefault, imagePositionList, isLoading } = this.state;
    const { certIdTipVisible } = this.state;
    const bodyPartList = this.props.bodyPartList || [];
    const { getFieldDecorator } = this.props.form;

    const api = window.store.getState().api;
    const userId = api.user.info.id;
    const disabled =
      viewType === 'detail' && selectedDicom.createUser !== userId;

    let imageList = this.getImageList(viewType);

    const roleInfo = api.user.info.operationAuths || '';
    const isAnonymity = roleInfo.includes('S');
    const IDTypeDict = api.current.IDTypeDict || [];
    const cardTypeDict = api.current.cardTypeDict || [];
    const nationalDict = api.current.nationalDict || [];
    const doingArray = [11, 21, 40];
    const buttons = [
      <Button
        key="cancel"
        onClick={() => this.handleCancel(false, 'cancel')}
        type="default"
        className="btn-cancel"
      >
        取消
      </Button>,
    ];
    const sexOptions = [
      { label: '男', value: 'M' },
      { label: '女', value: 'F' },
      { label: '未知', value: '' },
    ];
    if (viewType === 'detail') {
      if (selectedDicom.createUser === userId) {
        buttons.push(
          <>
            {doingArray.indexOf(selectedDicom.state) >= 0 ? ( //有其他医生正在处理此报告，不可以重新申请
              <Button
                key="submit"
                type="primary"
                loading={confirmLoading}
                onClick={this.handleReApply}
                className="btn-ok"
              >
                重新申请
              </Button>
            ) : (
              <Popconfirm
                placement="topRight"
                title="报告还没处理完成，确定要重新申请吗？"
                onConfirm={e => this.handleOk('update', e)}
                okText="确定"
                cancelText="取消"
                key="confirm"
              >
                <Button
                  className="btn-ok"
                  type="primary"
                  loading={confirmLoading}
                >
                  重新申请
                </Button>
              </Popconfirm>
            )}
          </>
        );
      }
    } else {
      buttons.push(
        <Button
          key="submit"
          type="primary"
          loading={confirmLoading}
          onClick={e => this.handleOk('new', e)}
          className="btn-ok"
        >
          申请
        </Button>
      );
    }
    return (
      <div className="group-modal" id="reportApply">
        {isLoading && (
          <div className="spin-box-bg">
            <Spin indicator={<Icon type="loading" spin />} />
          </div>
        )}
        <Modal
          title="患者信息"
          visible={visible}
          width="100%"
          height="100%"
          ref={this.modal}
          id="modal"
          className="group-manager group-manager-apply"
          onCancel={() => this.handleCancel(false, 'close')}
          footer={buttons}
          centered={true}
          keyboard={false}
          maskClosable={false}
        >
          <div className="report-list-modal">
            {/* 弹出框 */}
            <Form className="ant-advanced-search-form">
              <div className="type-title">患者信息录入</div>
              <Form.Item label="患者姓名" colon={false} className="width1">
                {getFieldDecorator('patName', {
                  rules: [{ required: true, message: '请填写患者姓名' }],
                  initialValue: selectedDicom.patName,
                })(<Input placeholder="请填写患者姓名" disabled={disabled} />)}
              </Form.Item>
              {isAnonymity && (
                <Form.Item label=" " colon={false} className="anonymity width1">
                  {getFieldDecorator('patName1', {
                    initialValue: '***',
                  })(<Input disabled={true} />)}
                </Form.Item>
              )}
              <Form.Item label="患者年龄" colon={false} className="width1">
                {getFieldDecorator('patAge', {
                  rules: [{ required: true, message: '请填写患者年龄' }],
                  initialValue: selectedDicom.patAge,
                })(<Input placeholder="请填写患者年龄" disabled={disabled} />)}
              </Form.Item>
              {isAnonymity && (
                <Form.Item label=" " colon={false} className="anonymity width1">
                  {getFieldDecorator('patAge1', {
                    initialValue: '***',
                  })(<Input disabled={true} />)}
                </Form.Item>
              )}
              <Form.Item label="患者性别" colon={false} className="width1">
                {getFieldDecorator('patSex', {
                  rules: [{ required: true, message: '请选择患者性别' }],
                  initialValue: selectedDicom.patSex,
                })(
                  <Radio.Group disabled={disabled}>
                    {sexOptions.map((item, index) => (
                      <Radio key={index} value={item.value}>
                        {item.label}
                      </Radio>
                    ))}
                  </Radio.Group>
                )}
              </Form.Item>
              {isAnonymity && (
                <Form.Item label=" " colon={false} className="anonymity width1">
                  {getFieldDecorator('patSex1', {})(
                    <Radio.Group disabled={true}>
                      {sexOptions.map((item, index) => (
                        <Radio key={index} value={item.value}>
                          {item.label}
                        </Radio>
                      ))}
                    </Radio.Group>
                  )}
                </Form.Item>
              )}
              <Form.Item label="证件类型" colon={false} className="width1">
                {getFieldDecorator('idType', {
                  rules: [{ required: true, message: '请选择证件类型' }],
                  initialValue: selectedDicom.idType || '',
                })(
                  <Select
                    placeholder="请选择检查类型"
                    disabled={disabled}
                    getPopupContainer={triggerNode => triggerNode.parentNode}
                    onChange={this.handleIDType}
                  >
                    {IDTypeDict.map((item, index) => (
                      <Option key={index} value={item.code}>
                        {item.name}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
              <Form.Item label="证件号码" colon={false} className="width1">
                {getFieldDecorator('idNumber', {
                  rules: [
                    { validator: this.IDNoValidator },
                    { required: true, message: ' ' },
                  ],
                  initialValue: selectedDicom.idNumber || '',
                })(
                  <Input
                    placeholder="请输入证件号码"
                    disabled={disabled}
                    maxLength={18}
                  />
                )}
              </Form.Item>
              <Form.Item label="出生年月" colon={false} className="width1">
                <ConfigProvider locale={zh_CN}>
                  {getFieldDecorator('birthday', {
                    initialValue: selectedDicom.birthday
                      ? moment(selectedDicom.birthday, dateFormat)
                      : null,
                    value: selectedDicom.birthday
                      ? moment(selectedDicom.birthday, dateFormat)
                      : null,
                    rules: [{ required: true, message: '请选择出生年月' }],
                  })(
                    <DatePicker
                      format={dateFormat}
                      showTime
                      placeholder="请选择出生年月"
                      disabled={disabled}
                      style={{ width: '100%', minWidth: '100%' }}
                    />
                  )}
                </ConfigProvider>
              </Form.Item>
              <Form.Item label="民族" colon={false} className="width1">
                {getFieldDecorator('national', {
                  initialValue: selectedDicom.national || '',
                  rules: [{ required: true, message: '请选择民族' }],
                })(
                  <Select
                    placeholder="请选择民族"
                    disabled={disabled}
                    getPopupContainer={triggerNode => triggerNode.parentNode}
                  >
                    {nationalDict.map((item, index) => (
                      <Option key={index} value={item.code}>
                        {item.name}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
              <Form.Item label="详细地址" colon={false} className="width2">
                {getFieldDecorator('address', {
                  initialValue: selectedDicom.address || '',
                })(<Input placeholder="请输入详细地址" disabled={disabled} />)}
              </Form.Item>
              <Form.Item label="联系方式" colon={false} className="width1">
                {getFieldDecorator('mobileNumber', {
                  initialValue: selectedDicom.mobileNumber || '',
                })(
                  <Input
                    placeholder="请输入联系方式"
                    disabled={disabled}
                    maxLength={11}
                  />
                )}
              </Form.Item>
              <Form.Item label="监护人身份证" colon={false} className="width1">
                {getFieldDecorator('guardianCertId', {
                  initialValue: selectedDicom.guardianCertId || '',
                })(
                  <Input
                    placeholder="请输入监护人身份证"
                    disabled={disabled}
                    maxLength={18}
                  />
                )}
              </Form.Item>
              <Form.Item label="监护人姓名" colon={false} className="width1">
                {getFieldDecorator('guardianName', {
                  initialValue: selectedDicom.guardianName || '',
                })(
                  <Input
                    placeholder="请输入监护人姓名"
                    disabled={disabled}
                    maxLength={50}
                  />
                )}
              </Form.Item>
              <Form.Item label="患者卡类型" colon={false} className="width1">
                {getFieldDecorator('cardType', {
                  initialValue: selectedDicom.cardType || '',
                })(
                  <Select
                    placeholder="请选择患者卡类型"
                    disabled={disabled}
                    getPopupContainer={triggerNode => triggerNode.parentNode}
                  >
                    {cardTypeDict.map((item, index) => (
                      <Option key={index} value={item.code}>
                        {item.name}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
              <Form.Item label="患者卡号" colon={false} className="width1">
                {getFieldDecorator('cardNo', {
                  initialValue: selectedDicom.cardNo || '',
                })(<Input placeholder="请输入患者卡号" disabled={disabled} />)}
              </Form.Item>
              <div className="type-title">检查信息录入</div>
              <Form.Item label="检查类型" colon={false} className="width1">
                {getFieldDecorator('modality', {
                  rules: [{ required: true, message: '请选择检查类型' }],
                  initialValue: selectedDicom.modality || 'DR',
                })(
                  <Select
                    placeholder="请选择检查类型"
                    disabled={disabled}
                    getPopupContainer={triggerNode => triggerNode.parentNode}
                  >
                    {['DR', 'DX', 'CR'].map((item, index) => (
                      <Option key={index} value={item}>
                        {item}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
              <Form.Item label="患者编号" colon={false} className="width1">
                {getFieldDecorator('patId', {
                  initialValue: selectedDicom.patId || null,
                })(<Input placeholder="请填写患者编号" disabled={disabled} />)}
              </Form.Item>
              <Form.Item label="检查编号" colon={false} className="width1">
                {getFieldDecorator('accessionNumber', {
                  initialValue: selectedDicom.accessionNumber || null,
                })(<Input placeholder="请填写检查编号" disabled={disabled} />)}
              </Form.Item>
              <Form.Item label="影像编号" colon={false} className="width1">
                {getFieldDecorator('imagesNumber', {
                  initialValue: selectedDicom.imagesNumber || null,
                })(<Input placeholder="请填写影像编号" disabled={disabled} />)}
              </Form.Item>
              <Form.Item label="住院号" colon={false} className="width1">
                {getFieldDecorator('hospitalizedNumber', {
                  initialValue: selectedDicom.hospitalizedNumber || null,
                })(<Input placeholder="请填写住院号" disabled={disabled} />)}
              </Form.Item>
              <Form.Item label="急诊" colon={false} className="width1">
                {getFieldDecorator('emergencyFlag', {
                  rules: [{ required: true, message: '请选择是否急诊' }],
                  initialValue:
                    selectedDicom.emergencyFlag === undefined
                      ? isNightDefault
                      : selectedDicom.emergencyFlag,
                })(
                  <Select
                    placeholder="是否急诊"
                    disabled={disabled}
                    getPopupContainer={triggerNode => triggerNode.parentNode}
                  >
                    {emergencyOption()}
                  </Select>
                )}
              </Form.Item>
              <Form.Item label="检查时间" colon={false} className="width1">
                <ConfigProvider locale={zh_CN}>
                  {getFieldDecorator('studyDateTime', {
                    initialValue: selectedDicom.studyDateTime
                      ? moment(selectedDicom.studyDateTime, timeFormat)
                      : null,
                  })(
                    <DatePicker
                      format={timeFormat}
                      showTime
                      placeholder="请选择检查时间"
                      disabled={disabled}
                    />
                  )}
                </ConfigProvider>
              </Form.Item>
              <Form.Item label="患者来源" colon={false} className="width1">
                {getFieldDecorator('patientSource', {
                  initialValue: selectedDicom.patientSource,
                })(
                  <Select
                    placeholder="请选择患者来源"
                    disabled={disabled}
                    onChange={this.changePatientSource}
                    getPopupContainer={triggerNode => triggerNode.parentNode}
                  >
                    {patientSourceOption()}
                  </Select>
                )}
              </Form.Item>
              {imagePositionList.map((item, index) => {
                let list = [];
                if (viewType === 'detail') {
                  let ids = item.checkPosture || [];
                  let name = item.checkPostureName || [];
                  list = ids.map((item, index) => item + '_' + name[index]);
                  list = list.length > 0 ? list : null;
                }
                return (
                  <div key={index}>
                    <Form.Item label="检查部位" className="width1">
                      {getFieldDecorator(`part_${index}`, {
                        rules: [{ required: true, message: '请选择检查部位' }],
                        initialValue: item.bodyPart
                          ? item.bodyPart + '_' + item.bodyPartName
                          : null,
                      })(
                        <Select
                          placeholder="选择检查部位"
                          showSearch
                          disabled={disabled}
                          onChange={value => this.setPositionList(index, value)}
                          getPopupContainer={triggerNode =>
                            triggerNode.parentNode
                          }
                        >
                          {bodyPartList.map((item, index) => (
                            <Option
                              value={item.code + '_' + item.name}
                              key={index}
                            >
                              {item.name}
                            </Option>
                          ))}
                        </Select>
                      )}
                    </Form.Item>
                    <Form.Item label="检查体位" className="width1">
                      {getFieldDecorator(`position_${index}`, {
                        rules: [{ required: true, message: '请选择检查体位' }],
                        initialValue: list,
                      })(
                        <Select
                          mode="multiple"
                          placeholder="选择检查体位"
                          disabled={disabled}
                          onChange={value =>
                            this.handlePostureChange(index, value)
                          }
                          getPopupContainer={triggerNode =>
                            triggerNode.parentNode
                          }
                        >
                          {(item.positionList || []).map((item, index) => (
                            <Option
                              value={item.code + '_' + item.name}
                              key={index}
                            >
                              {item.name}
                            </Option>
                          ))}
                        </Select>
                      )}
                    </Form.Item>
                    <div className="width1">
                      <Button
                        icon="minus-circle"
                        type="danger"
                        style={{ marginTop: '2px' }}
                        disabled={imagePositionList.length === 1 || disabled}
                        onClick={() => this.delPart(index)}
                      >
                        删除部位
                      </Button>
                      <Button
                        icon="plus-circle"
                        type="primary"
                        disabled={disabled}
                        style={{ marginTop: '3px', marginLeft: '10px' }}
                        onClick={this.addPart}
                      >
                        添加部位
                      </Button>
                    </div>
                  </div>
                );
              })}
              <div className="apply-imgs">
                <Form.Item label="申请影像" colon={false}>
                  {imageList}
                </Form.Item>
                <Button
                  type="primary"
                  shape="circle"
                  icon="plus"
                  className="apply-plus"
                  onClick={this.showImgList}
                />
              </div>
              <Form.Item label="申请项目" colon={false} className="width3">
                {getFieldDecorator('applicationItem', {
                  initialValue: selectedDicom.applicationItem || null,
                  rules: [{ required: true, message: '申请项目不能为空' }],
                })(<Input placeholder="请填写申请项目" disabled={true} />)}
              </Form.Item>
              <Form.Item label="病情描述" colon={false} className="width3">
                {getFieldDecorator('description', {
                  rules: [{ required: true, message: '请填写病情描述' }],
                  initialValue: selectedDicom.description || null,
                })(
                  <TextArea
                    placeholder="请填写病情描述"
                    autosize={false}
                    disabled={disabled}
                  />
                )}
              </Form.Item>
              <Form.Item label="既往病史" colon={false} className="width3">
                {getFieldDecorator('medicalHistory', {
                  rules: [{ required: true, message: '请填写既往病史' }],
                  initialValue: selectedDicom.medicalHistory || null,
                })(
                  <TextArea
                    placeholder="请填写既往病史"
                    autosize={false}
                    disabled={disabled}
                  />
                )}
              </Form.Item>
              <Form.Item label="患者病历" colon={false} className="width3">
                {getFieldDecorator('thisemr', {
                  initialValue: selectedDicom.thisemr || null,
                })(
                  <TextArea
                    placeholder="请填写患者病历"
                    autosize={false}
                    disabled={disabled}
                    maxLength={1000}
                  />
                )}
              </Form.Item>
              <Form.Item label="初步诊断" colon={false} className="width3">
                {getFieldDecorator('diagnosis', {
                  initialValue: selectedDicom.diagnosis || null,
                })(
                  <TextArea
                    placeholder="请填写初步诊断内容"
                    autosize={false}
                    disabled={disabled}
                    maxLength={1000}
                  />
                )}
              </Form.Item>
              <Form.Item label="会诊目的" colon={false} className="width3">
                {getFieldDecorator('purpose', {
                  initialValue: selectedDicom.purpose || null,
                })(
                  <TextArea
                    placeholder="请填写会诊目的"
                    autosize={false}
                    disabled={disabled}
                    maxLength={1000}
                  />
                )}
              </Form.Item>
              {selectedDicom.state > 1 && (
                <div>
                  <Form.Item label="申请医生" colon={false} className="width3">
                    {getFieldDecorator('createUserName', {})(
                      <span>{selectedDicom.createUserName}</span>
                    )}
                  </Form.Item>
                  <Form.Item label="申请时间" colon={false} className="width3">
                    <ConfigProvider locale={zh_CN}>
                      {getFieldDecorator('time', {})(
                        <span>{selectedDicom.createTime}</span>
                      )}
                    </ConfigProvider>
                  </Form.Item>
                </div>
              )}
            </Form>
          </div>
        </Modal>
        <ApplyImgList
          visible={this.state.applyImgListVisible}
          selectedDicom={selectedDicom}
          hideImgList={this.hideImgList}
          onSubmit={this.addMoreImg}
        />
        {certIdTipVisible && (
          <div className="certid-tip">
            <div className="content">
              <p>
                根据互联网医院监管平台要求，请在申请诊断前先去完善申请人姓名和补充身份证号，提交后即可进行诊断申请。
              </p>
              <p>
                <Button type="primary" onClick={this.applyToCertId}>
                  完善信息
                </Button>
              </p>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default Form.create()(Apply);
